import api from "../config/api";
import { Task } from "../types/Task";

const API_URL = "/task";

// GET all
export const getTasks = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

// GET by ID
export const getTaskById = (id: number) => api.get(`${API_URL}/?id=${id}`);

// POST new
export const createTask = (data: Task) => api.post(`${API_URL}/`, data);

// PUT update
export const updateTask = (id: number, data: Task) =>
  api.put(`${API_URL}/?id=${id}`, data);

// DELETE
export const deleteTask = (id: number) => api.delete(`${API_URL}/?id=${id}`);
